import { Component } from '@angular/core';
import { PrimitiveDropdownOptionsPipe } from '@app/sharedModule/pipes/pipes';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { OrderEditing } from '@pdqdev/pdq-shared/dist/interfaces';
import { capitalize } from '@utils/string-utils';
enum PeriodTimeUnitOption {
  MINUTES = 'minutes',
  HOURS = 'hours',
}
@Component({
  selector: 'order-editing-form-period',
  standalone: false,
  templateUrl: './order-editing-form-period.component.html',
  styleUrl: './order-editing-form-period.component.scss',
})
export class OrderEditingFormPeriodComponent {
  timeUnitOptions = PrimitiveDropdownOptionsPipe.transform(Object.values(PeriodTimeUnitOption), capitalize);
  capitalize = capitalize;
  constructor(public orderEditingService: OrderEditingService) {}

  onTimeUnitChange({ value }: { value: OrderEditing.PeriodType }) {
    this.orderEditingService.form.get('template.periods.type').setValue(value);
    this.orderEditingService.form.get('template.periods.type').markAsDirty();
  }
}
